module.exports = __webpack_public_path__ + "img/scene6.f344259a.gif";